import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { RadioModule } from 'z3k-config';
import { unpack_validation } from 'z3k-parser/validation/types';
import { RadioSensors433List } from './433';
import { RadioSensors868List } from './868';
import { Z3kDragDropContainer } from '../../utils/drag-drop-drawer/container';
export function RadioSensorsList() {
    const childrenItem = (selected_item_id) => {
        return (_jsxs(_Fragment, { children: [_jsx(RadioSensors433List, { selected_item_id: selected_item_id }), _jsx(RadioSensors868List, { selected_item_id: selected_item_id })] }));
    };
    return _jsx(Z3kDragDropContainer, { childrenItem: childrenItem });
}
const fields = ['radiosensors', 'radiosensors433'];
RadioSensorsList.isError = (validation_result) => {
    return fields.reduce((prev, current) => prev || !!unpack_validation(validation_result, current), false);
};
RadioSensorsList.isWarning = RadioSensorsList.isError;
RadioSensorsList.isShown = (is_service_view, config, device_spec, is_staff, is_climatic) => {
    return (!is_climatic &&
        (device_spec.io.has_radiosensors || device_spec.io.has_radiosensors_433) &&
        RadioModule.get.all(config).length > 0);
};
